import { CAT_DISPLAY } from './cats';
import type { CatId } from '../race/types';
import type { HudStore } from './store';

/** Screen position of a cat's head, published by the world. Missing or hidden cats get no tag. */
export interface TagPosition { id: CatId; x: number; y: number; visible: boolean; closeUp?: boolean }
export type TagSource = () => TagPosition[];

export function NameTags({ store, positions }: { store: HudStore; positions: TagPosition[] }) {
  const snap = store.snapshot.value;
  if (!snap || !positions.length) return null;
  return (
    <div class="name-tags" aria-hidden="true">
      {positions.filter((p) => p.visible).map((p) => {
        const c = snap.cats.find((k) => k.id === p.id);
        if (!c) return null;
        return (
          <span key={p.id} class={`name-tag${p.closeUp ? ' faded' : ''}`} style={{ transform: `translate(${p.x}px, ${p.y}px) translate(-50%, -100%)`, '--cat': CAT_DISPLAY[p.id].colour }}>
            <b>{c.place}</b> {CAT_DISPLAY[p.id].short}
          </span>
        );
      })}
    </div>
  );
}
